import { useEffect, useState } from 'react';
import { supabaseClient } from '../../config/supabase';

export default function ManualDriverActivation({ driver, onActivated }) {
    const [allowed, setAllowed] = useState(false);
    const [open, setOpen] = useState(false);
    const [attestation, setAttestation] = useState(false);
    const [note, setNote] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (driver.status !== 'onboarding') return;
        let mounted = true;
        supabaseClient.rpc('bl388_can_manual_onboard').then(({ data, error: accessError }) => {
            if (!mounted) return;
            setAllowed(!accessError && data === true);
            if (accessError) setError(`Manual onboarding access could not be checked: ${accessError.message}`);
        }).catch((e) => {
            if (mounted) setError(`Manual onboarding access could not be checked: ${e.message || 'Request failed.'}`);
        });
        return () => { mounted = false; };
    }, [driver.status]);

    const activate = async () => {
        setError(null);
        if (!attestation || !note.trim()) {
            setError('Verify the offline documents and enter a note.');
            return;
        }
        setSaving(true);
        try {
            const { data, error: saveError } = await supabaseClient.rpc('bl388_activate_driver_manually', {
                p_driver_id: driver.id, p_attestation: attestation, p_note: note.trim()
            });
            if (saveError) throw saveError;
            if (!data) throw new Error('Driver activation was not confirmed. Reload the roster before retrying.');
            setOpen(false);
            setNote('');
            setAttestation(false);
            await onActivated();
        } catch (e) {
            setError(e.message || 'Manual onboarding failed.');
        } finally {
            setSaving(false);
        }
    };

    if (driver.status !== 'onboarding') return null;
    return (
        <div data-m7-touch>
            {error && !open && <p role="alert" className="text-red-600 text-xs">{error}</p>}
            {allowed && <button onClick={() => { setOpen(true); setError(null); }} className="block mt-2 border rounded px-2 py-1 text-xs">Mark Active (manual onboarding)</button>}
            {open && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div role="dialog" aria-label="Manual driver onboarding" className="bg-[var(--surface-raised)] text-[var(--ink)] rounded-lg p-6 max-w-lg w-full space-y-4">
                        <h2 className="text-xl font-bold">Mark Active (manual onboarding)</h2>
                        <p>Your verification and note will be saved in the audit trail. This driver can then receive trip assignments.</p>
                        {error && <p role="alert" className="text-red-600">{error}</p>}
                        <label className="block"><input type="checkbox" checked={attestation} onChange={(e) => setAttestation(e.target.checked)} /> I verified this driver's documents offline</label>
                        <label className="block">Required note
                            <textarea aria-label="Manual onboarding note" value={note} onChange={(e) => setNote(e.target.value)} className="block w-full border rounded p-2 bg-[var(--surface-sunken)]" />
                        </label>
                        <button disabled={saving} onClick={() => setOpen(false)} className="border rounded px-3 py-2">Cancel</button>
                        <button disabled={saving} onClick={activate} className="ml-2 bg-orange-600 text-white rounded px-3 py-2">{saving ? 'Saving…' : 'Confirm Active'}</button>
                    </div>
                </div>
            )}
        </div>
    );
}
